import React from 'react';
import MuiCheckbox from '@mui/material/Checkbox';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { IProps } from './IProps';
import { checkboxStatuses } from './checkbox-statuses';

const Component: React.FC<IProps> = ({
    label,
    name,
    value,
    status,
    onClick,
}) => {
    const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { value } = e.target as HTMLButtonElement;
        onClick(value);
    };
    return (
        <>
            <MuiCheckbox
                className="checkbox"
                checkedIcon={<CheckBoxIcon className="checkbox__ico" />}
                icon={<CheckBoxOutlineBlankIcon className="checkbox__ico" />}
                indeterminateIcon={
                    <IndeterminateCheckBoxIcon className="checkbox__ico" />
                }
                name={name}
                value={value}
                checked={status !== checkboxStatuses.unchecked}
                indeterminate={status === checkboxStatuses.indeterminate}
                onClick={handleClick}
            />
        </>
    );
};

export const Checkbox = React.memo(Component);
